export const BuildInfo = {timestamp:1793732861000}
